import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-270" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-271" data-mp="18228gsl3fjf4">
        <div className="text-center" data-id="element-272" data-mp="1zv1m989uh1lw">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-273" data-mp="1zw4bzcvfky08">
            100+ AI PROMPTS FOR 911 DISPATCHERS: THE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-274" data-mp="1qud88dkgb190">
            📚 The 6-Volume Dispatcher Toolkit
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-275" data-mp="1vs4yz49d0hbm">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-276" data-mp="fey8x34rrxaq">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-277" data-mp="3o8oovqhol2oy">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-278" data-mp="3jamyekhxe13g" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-279" data-mp="60pjiase9pwx">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-280" data-mp="kq4xsraqo2vq">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-281" data-mp="tse578apng4w">
                  <span aria-hidden="true" data-id="element-282" data-mp="prua0a9p6mle">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-283" data-mp="wvk8sbauzj5o">{t.desc}</p>
              <ul className="mt-3 space-y-1.5" data-id="element-284" data-mp="11tc1v8n8pbbg">
                {t.prompts.map(pr => <li key={pr} className="flex items-start gap-2 text-[13px] leading-snug text-plum/75" data-id="element-285" data-mp="16rnbbi9mhjt5">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-blush" strokeWidth={3} data-id="element-286" data-mp="1bjowxusokmvu" />
                    {pr}
                  </li>)}
              </ul>
              <p className="mt-2 pb-1 text-xs font-semibold text-plum/45" data-id="element-287" data-mp="1kjbmnjc1s492">+ 14 more complete prompts</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-288" data-mp="1pjpw95tarm97">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-289" data-mp="1uhrgvv6dftms">
            ✅ Every Volume includes:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-290" data-mp="3rbcjqxdzcz0x">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-291" data-mp="49q7zao6gnj">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-292" data-mp="2dervrq421hby" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}